import { type TagProps as AntTagProps, Flex } from 'antd';
import React, { type FC } from 'react';
import { TruncateText } from '@/components/TruncateText';
import { Tooltip } from '@/components/tooltip/Tooltip';
import { useTheme } from 'styled-components';
import { StyledTag } from './StyledTag';
import { getTagIconByType } from './utils/getTagIconByType';
import type { TagType } from './enums/TagType';
import { Icon } from '../icon';

export type TagProps = AntTagProps & {
  type?: TagType;
  maxLength?: number;
  hasTooltip?: boolean;
  showIcon?: boolean;
  tooltipContent?: React.ReactNode | string;
};

export const Tag: FC<TagProps> = props => {
  const {
    children,
    maxLength = 30,
    hasTooltip = true,
    type,
    closable,
    showIcon = false,
    icon,
    tooltipContent,
    ...restProps
  } = props;
  const theme = useTheme();

  const Wrapper = hasTooltip ? Tooltip : React.Fragment;

  return (
    <Wrapper {...(hasTooltip ? { title: tooltipContent ?? children } : {})}>
      <StyledTag
        closeIcon={
          closable && (
            <Flex align="center">
              <Icon $fontSize={theme.typography.fontSize[4]} iconString="close" />
            </Flex>
          )
        }
        icon={
          icon && showIcon ? (
            <Flex align="center">{icon}</Flex>
          ) : (
            type && showIcon && <Flex align="center">{getTagIconByType(type, theme)}</Flex>
          )
        }
        type={type}
        {...restProps}
      >
        {typeof children === 'string' ? (
          <TruncateText hasTooltip={false} maxLength={maxLength} text={children} />
        ) : (
          children
        )}
      </StyledTag>
    </Wrapper>
  );
};
